import { useContext } from 'react'

import { UnifiedContext } from '@/contexts/UnifiedContext'
import { useUserStore } from '@/stores/user'

export function useSelectionScope() {
  const context = useContext(UnifiedContext)
  const userId = useUserStore((state) => state.id)
  return JSON.stringify([
    userId,
    context?.mode ?? 'platform',
    context?.teamResID,
    context?.memberResID,
  ])
}
